export default __webpack_public_path__ + "static/media/sexy_banner.544f098c.png";